import { PropsWithChildren } from "react";

import { Variants } from "@enkor/framer-motion";

import { CloseIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";
import useModalState from "@logics/hooks/useModalState";

import * as S from "./NoticeModal.style";

const sheetVariants: Variants = {
  hidden: { x: "-50%", y: "-50%", scale: 1.2, opacity: 0 },
  visible: {
    x: "-50%",
    y: "-50%",
    scale: 1,
    opacity: 1,
    transition: { duration: 0.4, ease: [0.05, 0.7, 0.1, 1.0] },
  },
  exit: {
    x: "-50%",
    y: "-50%",
    scale: 1.2,
    opacity: 0,
    transition: { duration: 0.2, ease: [0.3, 0.0, 0.8, 0.15] },
  },
};

interface NoticeModalProps {
  modal: {
    title: string;
    description?: string;
  };
  closeButton?: {
    withXIcon?: boolean;
    elementId?: string;
    onClickClose?: () => void;
  };
  ctaButton: {
    elementId?: string;
    text?: string;
    onClickConfirm: () => void;
  };
}

const NoticeModal = ({
  modal,
  closeButton,
  ctaButton,
  children,
}: PropsWithChildren<NoticeModalProps>) => {
  const { closeModal } = useModalState();

  return (
    <S.Container
      variants={sheetVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <S.ModalHeader name="h6">{modal.title}</S.ModalHeader>
      {modal?.description && (
        <S.ModalContent name="m">{modal.description}</S.ModalContent>
      )}

      {children && <>{children}</>}

      {ctaButton && (
        <S.ConfirmButton
          type="button"
          id={ctaButton?.elementId}
          onClick={ctaButton?.onClickConfirm}
        >
          {ctaButton?.text || "OK"}
        </S.ConfirmButton>
      )}

      {closeButton?.withXIcon && (
        <S.CloseButton
          type="button"
          id={closeButton?.elementId}
          onClick={() => {
            closeButton?.onClickClose?.();
            closeModal();
          }}
        >
          <CloseIcon strokeColor={grayScale.white} />
        </S.CloseButton>
      )}
    </S.Container>
  );
};

export default NoticeModal;
